/**
 * @generated SignedSource<<596772e300eef42caf05f14bbb7c9290>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BjfBlockState = "ACTIVE" | "CLAIMABLE" | "CLAIMED" | "FINISHED" | "%future added value";
export type useBJFMiningStateQuery$variables = {};
export type useBJFMiningStateQuery$data = {
  readonly getBjfMiningState: {
    readonly unpaidBjf: number;
    readonly unpaidBjfUsd: number;
    readonly unlockDate: string;
    readonly totalWager: number;
    readonly earnedBjf: number;
    readonly earnedBjfUsd: number;
    readonly claimableBjf: number;
    readonly claimableBjfUsd: number;
    readonly progress: {
      readonly progressId: number;
      readonly betTarget: number;
      readonly betProgress: number;
      readonly state: BjfBlockState;
      readonly finished: boolean;
      readonly miningAmount: number;
      readonly payedOut: string | null;
      readonly payoutPrice: string | null;
      readonly insertedAt: any;
      readonly updatedAt: any;
    };
  };
};
export type useBJFMiningStateQuery = {
  variables: useBJFMiningStateQuery$variables;
  response: useBJFMiningStateQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BjfMiningState",
    "kind": "LinkedField",
    "name": "getBjfMiningState",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unpaidBjf",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unpaidBjfUsd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unlockDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalWager",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "earnedBjf",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "earnedBjfUsd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimableBjf",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "claimableBjfUsd",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BjfMiningRow",
        "kind": "LinkedField",
        "name": "progress",
        "plural": false,
        "selections": [
          {
            "alias": "progressId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betTarget",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "betProgress",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "finished",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "miningAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payedOut",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "payoutPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insertedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useBJFMiningStateQuery",
    "selections": (v0/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useBJFMiningStateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "9c7a0c573f07c2d52d84c4deccf04811",
    "id": null,
    "metadata": {},
    "name": "useBJFMiningStateQuery",
    "operationKind": "query",
    "text": "query useBJFMiningStateQuery {\n  getBjfMiningState {\n    unpaidBjf\n    unpaidBjfUsd\n    unlockDate\n    totalWager\n    earnedBjf\n    earnedBjfUsd\n    claimableBjf\n    claimableBjfUsd\n    progress {\n      progressId: id\n      betTarget\n      betProgress\n      state\n      finished\n      miningAmount\n      payedOut\n      payoutPrice\n      insertedAt\n      updatedAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fade775c732ad8e8cb18299796be403e";

export default node;
